import * as React from "react"
import { cn } from "../../lib/utils"

type BadgeTone = "neutral" | "brand" | "success" | "danger"

const tones: Record<BadgeTone, string> = {
  neutral: "bg-white/[0.06] text-fg-muted ring-white/10",
  brand: "bg-brand/15 text-[#c9b3ff] ring-brand/25",
  success: "bg-success/12 text-success ring-success/25",
  danger: "bg-danger/12 text-danger ring-danger/25",
}

interface BadgeProps extends React.ComponentProps<"span"> {
  tone?: BadgeTone
}

function Badge({ tone = "neutral", className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-medium ring-1 ring-inset",
        tones[tone],
        className
      )}
      {...props}
    />
  )
}

export { Badge }
